import { get, post } from './request';

// 海航金鹏"金卡直升挑战" 报名
// 注意：URL 含 "gapi"，request.js 会自动路由到 gapi 后端域名(alpha 域名时是 alpha-edge-api)，并自动带上 Bearer token。
// 后端固定挑战级别(金卡)，前端不传级别；目前后端仅使用 id_no，姓名/手机号暂不传后端。
// 后端响应结构 { code, msg, data }，data: { cid, s_tid, error_message }
export function hnairChallengeRegister(idNo) {
  return post('/gapi/app/hnair/challenge/register', { id_no: idNo });
}

// 是否已报名本活动(按登录会员查后端落库), 返回 { joined, cid }
// 用于按钮"已参与"态与进度查询, 替代仅存 localStorage(跨设备可靠)。
export function hnairChallengeJoined() {
  return get('/gapi/app/hnair/challenge/joined');
}

// 海航金鹏"金卡直升挑战" 挑战进度查询
// cid 不经前端: 后端用登录会员 vip_id 自查落库 cid 再问海航(避免越权查他人进度)。
// 后端响应结构 { code, msg, data }，data: { cid, tier_name, in_challenge, challenge_goal,
// need_challenge_segments, challenge_segments, need_challenge_point, challenge_point, challenge_end_date }
export function hnairChallengeProgress() {
  return get('/gapi/app/hnair/challenge/progress');
}

// 八大洲会员等级(gapi /vip/info), 返回体 { code, msg, data }, data.level: 橙1/银2/金3/黑金4。
// 用 gapi 而非 PHP myInfo: myInfo 的 level 经 objValue 转成了枚举对象/undefined, 不是纯数字。
export function hnairVipLevel() {
  return get('/gapi/app/vip/info');
}
